import React from 'react';
import { Routes } from '../Core/Constants'

const PasswordReset = () => {
    let T = window.Texts.login;
    return (
        <div className="lost-password-page">
            <div className="cover">
                <div className="headline">
                    <h1>{T.passwordChangedTitle}</h1>
                </div>
                <div className="inner-500">
                    <p /><p>{T.dearCustomer}</p>
                    <p>{T.passwordChangedText + ' '} <a href={Routes.Login} >{T.loginText}</a></p>
                </div>
            </div>
        </div>
    );
};

export default PasswordReset;